import { InfoCircleOutlined } from '@ant-design/icons'
import React, { useState } from 'react'

import { OrderForm } from '../Form/Order/OrderForm'
import { ShiftForm } from '../Form/Shift/ShiftForm'
import { SpecialPayForm } from '../Form/SpecialPay/SpecialPayForm'

export function PayPeriodDetail({ data, driver_id, setSelectedOrder, setShowingModal, triggerRefresh }) {
  const [shiftOverrideRequest, setShiftOverrideRequest] = useState()
  const [overrideOrderRequest, setOrderOverrideRequest] = useState()

  if (!data) return <NoContent />

  if (!data.shift_pay && !data.order_pay && !data.special_pay) return <NoContent />

  return (
    <div className='bg-1'>
      {data.shift_pay && (
        <ShiftForm
          shiftDate={data.date}
          shiftPay={data.shift_pay}
          driver_id={driver_id}
          triggerRefresh={triggerRefresh}
          shiftOverrideRequest={shiftOverrideRequest}
          setShiftOverrideRequest={setShiftOverrideRequest}
        />
      )}
      {data.order_pay &&
        data.order_pay.map((order) => (
          <OrderForm
            key={order.order_no}
            order={order}
            date={data.date}
            driverId={driver_id}
            setSelectedOrder={setSelectedOrder}
            setShowingModal={setShowingModal}
            triggerRefresh={triggerRefresh}
            overrideOrderRequest={overrideOrderRequest}
            setOrderOverrideRequest={setOrderOverrideRequest}
          />
        ))}
      {data.special_pay && <SpecialPayForm specialPay={data.special_pay} triggerRefresh={triggerRefresh} />}
    </div>
  )
}

function NoContent() {
  return (
    <b className='no-details center-flex-container p-4'>
      <InfoCircleOutlined className='pr-2' /> No Pay Period details are available at this time
    </b>
  )
}
